<template>
  <div>
    <b-modal
      id="modal-Agendamento"
      class="ScheduleModal"
      hide-header
      size="md"
      @hide="clear"
    >
      <span class="titleNew"> <b-icon-plus /> Novo Agendamento</span>
      <template #modal-footer>
        <div class="footerModal">
          <b-button
            size="sm"
            style="font-size: 12px; width: 140px"
            variant="dark"
            @click="handleForUpdate"
            >Salvar</b-button
          >

          <b-button
            size="sm"
            style="font-size: 12px; width: 140px"
            variant="dark"
            @click="printScheduling"
            >Imprimir <b-icon-printer class="ml-2"></b-icon-printer
          ></b-button>

          <b-button
            style="background: #bdbdbd; font-size: 12px; width: 140px"
            size="sm"
            variant="light"
            @click="clear"
            >Limpar
          </b-button>

          <b-button
            v-if="idSchedule"
            style="color: white; font-size: 12px; width: 140px"
            size="sm"
            variant="danger"
            @click="destroy"
            >Excluir <b-icon-trash class="ml-2"></b-icon-trash
          ></b-button>
        </div>
      </template>
      <div class="bodyScheduleContent">
        <InputSelect
          label="Tipo de agendamento"
          :items="typeOfSchedule"
          valueField="id"
          textField="name"
          :dataSelect.sync="teste.idTipoAgendamento"
          :openCreateModal="() => openModals('modalTypeOfSchedule')"
          ref="idTipoAgendamento"
        />

        <div class="selectPlus">
          <label class="fixedSelect2">Evento</label>
          <b-form-select
            class="borderInput shadow-none"
            value-field="value"
            text-field="text"
            :options="options"
            v-model="teste.tipo"
          >
          </b-form-select>
        </div>

        <div class="input-group">
          <input
            type="datetime-local"
            class="input borderInput"
            v-model="teste.dataAgenda"
          />
          <label class="fixedSelect2"> Data Do Evento </label>
        </div>

        <div class="selectPlus">
          <label class="fixedSelect2"></label>
          <InputInfinit
            style="width: 100%"
            label="Cliente"
            typeFilter="customer"
            :isEdit="teste.idCliente"
            :dataInput.sync="teste.idCliente"
            :onSearch="fillCustomerComboBoxWithPaginate"
            :openCreateModal="() => openModals('modalCreateCustomer')"
            :findAll="createdNewCustomer"
            :clearSelected="newOrder"
            @selectItem="handleDataCustomers"
          />
        </div>

        <div class="input-group">
          <input required class="input borderInput" v-model="teste.descricao" />
          <label class="fixedSelect2"> Descrição do Agendamento </label>
        </div>
      </div>
    </b-modal>
    <ModalCreateCustomer @getAllNewCustomer="handleCreatedNewCustomer" />
    <ModalCreateTypeOfSchedule @getNewTypeOfSchedule="getNewTypeOfSchedule" />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import api from "../../services/axios";
import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue";
import ServiceCustomer from "../../services/serviceCustomer";
import ModalCreateCustomer from "../Modals/ModalCreateCustomer.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import ModalCreateTypeOfSchedule from "../../components/Modals/ModalCreateTypeOfSchedule.vue";
import printReportSchedule from "../../reports/Schedule";

export default {
  props: {
    date: {
      type: String,
    },
    dataReadSchedule: {
      type: String,
    },
    typeOfSchedule: {
      type: Array,
    },
  },
  data() {
    return {
      teste: {
        descricao: "",
        tipo: "",
        dataAgenda: "",
        idCliente: "",
        idTipoAgendamento: "",
      },
      options: [
        { value: "Lembrete", text: "Lembrete" },
        { value: "Reunião", text: "Reunião" },
        { value: "Aniversario", text: "Aniversario" },
        { value: "Pagamento", text: "Pagamento" },
        { value: "Recebimento", text: "Recebimento" },
        { value: "Outro", text: "Outro" },
      ],
      idSchedule: "",
      createdNewCustomer: false,
      newOrder: false,
    };
  },
  components: {
    InputInfinit,
    ModalCreateCustomer,
    InputSelect,
    ModalCreateTypeOfSchedule,
  },
  mounted() {
    this.teste.dataAgenda = this.date;
  },
  watch: {
    async dataReadSchedule() {
      try {
        if (this.dataReadSchedule) {
          const { data } = await api.get(`/schedules/${this.dataReadSchedule}`);
          this.teste = data;
          this.idSchedule = data.id;

          this.$refs.idTipoAgendamento.valueItems = data.idTipoAgendamento;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    ...mapMutations(["SET_HTML_TO_PRINT"]),
    async saveSchedule() {
      try {
        const { data } = await api.post("/schedules", this.teste);
        this.idSchedule = data.id;
        this.$emit("dataSchedule", { id: this.idSchedule, ...this.teste });
        this.clear();
        this.$bvModal.hide("modal-Agendamento");
        this.$toast.open({
          message: "Agendamento salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível salvar agendamento",
          type: "warning",
        });
      }
    },

    async updateSchedule() {
      try {
        await api.put(`/schedules/${this.idSchedule}`, this.teste);

        this.$emit("updateSchedule");
        this.clear();

        this.$bvModal.hide("modal-Agendamento");
        this.$toast.open({
          message: "Agendamento atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível atualizar agendamento",
          type: "warning",
        });
      }
    },

    async destroy() {
      try {
        await api.delete(`/schedules/${this.idSchedule}`);

        this.$emit("updateSchedule");
        this.$toast.open({
          message: "Agendamento deletado com Sucesso",
          type: "success",
        });
        this.$bvModal.hide("modal-Agendamento");
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível deletar o agendamento",
          type: "warning",
        });
      }
    },

    handleForUpdate() {
      if (this.idSchedule) {
        this.updateSchedule();
      } else {
        this.saveSchedule();
      }
    },

    async fillCustomerComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceCustomer.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os clientes",
          type: "info",
        });
      }
    },
    getNewTypeOfSchedule() {
      this.$emit("getNewTypeOfSchedule");
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },

    handleDataCustomers(event) {
      this.dataCustomers = [event];
    },
    async printScheduling() {
      if (!this.idSchedule) {
        this.$toast.open({
          message: "Salve o agendamento antes de imprimir",
          type: "info",
        });
        return;
      }
      let html = await printReportSchedule("scheduling", this.idSchedule);
      this.SET_HTML_TO_PRINT(html);
    },

    clear() {
      this.teste = {};
      this.idSchedule = "";
      this.newOrder = !this.newOrder;
      this.$refs.idTipoAgendamento.valueItems = "";
      this.$emit("clear");
    },
  },
};
</script>
<style scoped>
.ScheduleModal {
  font-size: 13px;
}

.titleNew {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
}

.bodyScheduleContent {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.footerModal {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 1rem;
}
</style>
